import React from "react";
import { Overline } from "@/components/ui-kit";

export const PageHero = ({ overline, title, subtitle, image, align = "left" }) => (
  <section className="relative overflow-hidden bg-forest text-white" data-testid="page-hero">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/85" />
      </>
    )}
    <div className="grain" />
    <div className={`relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 ${align === "center" ? "text-center mx-auto max-w-4xl" : "max-w-3xl"}`}>
      {overline && <Overline className="mb-5">{overline}</Overline>}
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-tight text-balance">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-6 text-lg text-white/70 leading-relaxed max-w-2xl">{subtitle}</p>
      )}
    </div>
  </section>
);

export default PageHero;
